"use strict";

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if (!isIE11) {
  document.addEventListener('DOMContentLoaded', function () {
    // On scroll check position of items.
    // Get list of items tagged.
    // Run through items tagged and check their positions.
    // If item passes threshold trigger active.
    // Have attribute that says if active.
    // If active run animations.
    // Stop checking if active after being marked active.
    function tagGutenbergElementsForScrollEffects() {
      var index = 0,
          gutenberg_areas = document.querySelectorAll('.wp-block-latest-posts');

      for (index; index < gutenberg_areas.length; ++index) {
        gutenberg_areas[index].classList.add('scroll-trigger');
      }
    }

    function loadAddtionalElements() {
      var index = 0,
          media_areas = document.querySelectorAll('.wp-block-media-text:not(.is-style-no-animation) > .wp-block-media-text__media'),
          slider_media_areas = document.querySelectorAll('.slider__media');

      for (index; index < media_areas.length; ++index) {
        media_areas[index].insertAdjacentHTML('beforeend', '<span class="pill pill--red pill--one"></span><span class="pill pill--red pill--two"></span><span class="pill pill--red pill--three"></span><span class="pill pill--grey pill--four"></span><span class="pill pill--grey pill--five"></span>');
      }

      for (var i = 0; i < slider_media_areas.length; i += 1) {
        slider_media_areas[i].insertAdjacentHTML('beforeend', '<span class="pill pill--red pill--one"></span><span class="pill pill--red pill--two"></span><span class="pill pill--red pill--three"></span><span class="pill pill--grey pill--four"></span><span class="pill pill--grey pill--five"></span>');
      }
    }

    function loadAdditionalStyle() {
      var css = document.createTextNode('.wp-block-latest-posts li, .services-icons__icon-block, .service-circles__external-circle, .service-circles__internal-circle { opacity: 0; } .logo .bankers-bank-icon svg .right-b-line { fill: none; }'),
          _document = document,
          head = _document.head,
          style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(css);
      head.appendChild(style);
    }
    /**
     * See if the navigation is out of view and if it should apply the sticky class.
     */


    function checkNavSticky() {
      var globalNav = document.querySelector('.global'),
          mainNav = document.querySelector('#site-header');
      var mainNavPosition = getPosition(mainNav),
          mainNavHeight = mainNav.offsetHeight,
          stickyHeight = mainNavPosition.y + mainNavHeight;

      if (stickyHeight > window.scrollY) {
        mainNav.classList.remove('header--sticky');
      } else {
        mainNav.classList.add('header--sticky');
      }
    }
    /**
     * Check the scroll position of items.
     */


    function checkScrollPosition() {
      checkNavSticky(); // console.log('Window');
      // console.log(window.pageYOffset);
      // Create our variables.

      var index = 0,
          scroll_points = document.querySelectorAll('.scroll-trigger, .is-style-scroll-trigger');

      for (index; index < scroll_points.length; ++index) {
        var window_offset = window.pageYOffset + window.innerHeight * 0.65,
            element_position = getPosition(scroll_points[index]),
            scroll_active = scroll_points[index].classList.contains('scroll-active') ? true : false; // console.log('Window Inner Height');
        // console.log(window.innerHeight);
        // console.log('Window Offset');
        // console.log(window_offset);
        // console.log('Element Positions');
        // console.log(scroll_points[index]);
        // console.log(element_position.y);

        if (scroll_active) {
          // Things to check if item is in view.
          if (element_position.y > window_offset && element_position.y > window.innerHeight) {
            scroll_points[index].classList.remove('scroll-active');
          }
        } else {
          // Check if an item came into view.
          if (element_position.y <= window_offset || element_position.y <= window.innerHeight) {
            // Add our active class.
            scroll_points[index].classList.add('scroll-active'); // Check for the unique anime.js animations.

            if (scroll_points[index].classList.contains('bankers-bank-icon')) {
              var bankers_bank_icon_anime = anime.timeline({
                duration: 1000
              });
              bankers_bank_icon_anime.add({
                targets: scroll_points[index].querySelectorAll('svg .center-column'),
                scaleY: {
                  value: [0, 1],
                  duration: 300
                },
                translateY: {
                  value: [190, 0],
                  duration: 300,
                  easing: 'easeOutSine'
                },
                delay: anime.stagger(150, {
                  grid: [1, 3],
                  from: 'first'
                })
              });
              bankers_bank_icon_anime.add({
                targets: scroll_points[index].querySelectorAll('svg .right-b-line'),
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'easeInOutSine',
                duration: 1500,
                delay: function delay(el, i) {
                  return i * 250;
                },
                direction: 'alternate',
                fill: {
                  value: 'rgba(137,24,67,1)',
                  delay: 1000,
                  duration: 500
                },
                stroke: {
                  value: 'rgba(137,24,67,0)',
                  delay: 1000,
                  duration: 500
                }
              });
              bankers_bank_icon_anime.add({
                targets: scroll_points[index].querySelectorAll('svg .left-b-line'),
                opacity: [0, 1],
                translateX: [90, 0],
                easing: 'easeOutSine'
              });
              bankers_bank_icon_anime.play();
            } // Check for the unique anime.js animations.


            if (scroll_points[index].classList.contains('services-icons')) {
              var services_icons_anime = anime({
                autoplay: false,
                delay: anime.stagger(100, {
                  grid: [6, 1],
                  from: 'center'
                }),
                duration: 500,
                targets: scroll_points[index].querySelectorAll('.services-icons__icon-block'),
                translateY: [90, 0],
                scale: [0, 1],
                opacity: [0, 1],
                easing: 'easeOutQuart'
              });
              services_icons_anime.play();
            }

            if (scroll_points[index].classList.contains('wp-block-latest-posts')) {
              var latest_posts_anime = anime({
                autoplay: false,
                delay: anime.stagger(100),
                duration: 700,
                targets: scroll_points[index].querySelectorAll('.wp-block-latest-posts li'),
                translateX: [-480, 0],
                opacity: [0, 1],
                easing: 'easeOutQuart'
              });
              latest_posts_anime.play();
            }

            if (scroll_points[index].classList.contains('service-circles')) {
              var service_circles_anime = anime.timeline({
                autoplay: false
              }),
                  service_circles_icon_library = anime.timeline({
                autoplay: false
              }),
                  service_circles_icon_house = anime.timeline({
                autoplay: false
              });
              service_circles_icon_library.add({
                delay: anime.stagger(200, {
                  start: 550
                }),
                duration: 1000,
                targets: scroll_points[index].querySelectorAll('.service-circles__center-icon .library'),
                opacity: [0, 1],
                translateY: [10, 0],
                easing: 'easeOutQuart'
              });
              service_circles_icon_house.add({
                delay: 500,
                duration: 1000,
                targets: scroll_points[index].querySelectorAll('.service-circles__center-icon .house'),
                translateY: [0, 10],
                opacity: [1, 0],
                direction: 'reverse',
                easing: 'easeOutQuart'
              });
              service_circles_anime.add({
                delay: anime.stagger(400),
                duration: 1000,
                targets: scroll_points[index].querySelectorAll('.service-circles__external-circle, .service-circles__internal-circle'),
                opacity: [0, 1],
                rotate: [-90, 0],
                scale: [0, 1],
                easing: 'easeOutQuart'
              });
              service_circles_anime.add({
                delay: anime.stagger(200),
                duration: 500,
                targets: scroll_points[index].querySelectorAll('.service-circles__point.has-title .service-circles__link__point-title'),
                opacity: [0, 1],
                rotate: [-90, 0],
                scale: [0, 1],
                easing: 'easeOutQuart'
              });
              service_circles_icon_library.play();
              service_circles_icon_house.play();
              service_circles_anime.play();
            }

            if (scroll_points[index].classList.contains('wp-block-media-text__media')) {
              var media_pill_anime = anime.timeline({
                autoplay: false
              });
              media_pill_anime.add({
                delay: anime.stagger(100),
                duration: 1000,
                targets: scroll_points[index].querySelectorAll('.pill'),
                opacity: [0, 1],
                translateX: [-480, 0],
                scale: [0, 1],
                easing: 'easeOutQuart'
              }); // service_circles_anime.play();

              media_pill_anime.play();
            }
          }
        }
      }
    } // https://stackoverflow.com/questions/11805955/how-to-get-the-distance-from-the-top-for-an-element/24829409#24829409


    function getPosition(element) {
      var xPosition = 0;
      var yPosition = 0;

      while (element) {
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
      }

      return {
        x: xPosition,
        y: yPosition
      };
    } // Load our additional elements.


    loadAddtionalElements(); // Load our additional styles separately in case JS fails.

    loadAdditionalStyle(); // Tag the additional Gutenberg elements for animations.

    tagGutenbergElementsForScrollEffects(); // Add a listener to run on scroll and run it initially.

    window.addEventListener('scroll', checkScrollPosition);
    checkScrollPosition();
  });
}